import * as React from 'react';
import { useEffect, useState } from 'react';
import { levelPools } from '~config/levelPoolsConfig';
import { Button } from '~features/ui';

export function StakingDurationSlider({
  activeId,
  onChange,
}: {
  activeId: string;
  highlightLastN: number;
  onChange: (stakingId: string) => void;
}) {
  const [value, setValue] = useState(() =>
    levelPools.findIndex((p) => p.id === activeId),
  );

  useEffect(() => {
    setValue(levelPools.findIndex((p) => p.id === activeId));
  }, [activeId]);

  const lastIndex = levelPools.length - 1;
  const step = 100 / lastIndex;

  // Return button group
  return (
    <div className="flex justify-center gap-2 flex-wrap">
      {levelPools.map((pool, index) => (
        <Button
          key={pool.id}
          type={pool.id === activeId ? 'primary' : 'secondaryOutline'}
          size="sm"
          onClick={() => {
            onChange(pool.id);
            setValue(index);
          }}>
          <div className="text-white text-sm">
            {pool.lockPeriod.replace(' days', 'd')}
          </div>
        </Button>
      ))}
    </div>
  );
}
